import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';
import { Plus } from 'lucide-react';
import { CreateSegmentForm } from './create-segment-form.tsx';
import type { SegmentSegmentReadModel } from '@r/api/generated/client.schemas.ts';

interface CreateSegmentDialogProps {
  onCreated: (segment: SegmentSegmentReadModel) => void;
}

/** Modale de création d'un segment, avec le bouton déclencheur. */
export const CreateSegmentDialog: FC<CreateSegmentDialogProps> = ({ onCreated }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleSuccess = (segment: SegmentSegmentReadModel) => {
    setIsOpen(false);
    onCreated(segment);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button rounded="full">
          {t('admin.segments.create.cta')} <Plus />
        </Button>
      </DialogTrigger>

      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('admin.segments.create.dialog.title')}</DialogTitle>
          <DialogDescription>{t('admin.segments.create.dialog.description')}</DialogDescription>
        </DialogHeader>

        <CreateSegmentForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};
